/* eslint-disable */
export const RoutingHelper = {
    isOnlineBookingPath(value){
        return ["/public/booking"].includes(value);
    }
}